/**
 * TanStack Query hooks for `invoice-number-sequence-customization`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	invoiceNumberSequenceCustomizationQueryKeys,
	type CreateInvoiceNumberSequenceCustomizationBody,
	type ListInvoiceNumberSequenceCustomizationResponse,
	type InvoiceNumberSequenceCustomizationRow,
} from "./api";

export function useInvoiceNumberSequenceCustomizationList(): UseQueryResult<ListInvoiceNumberSequenceCustomizationResponse, Error> {
	return useQuery({
		queryKey: invoiceNumberSequenceCustomizationQueryKeys.list(),
		queryFn: list,
	});
}

export function useInvoiceNumberSequenceCustomizationCreate(): UseMutationResult<InvoiceNumberSequenceCustomizationRow, Error, CreateInvoiceNumberSequenceCustomizationBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceNumberSequenceCustomizationQueryKeys.all });
		},
	});
}

export function useInvoiceNumberSequenceCustomizationDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: invoiceNumberSequenceCustomizationQueryKeys.all });
		},
	});
}
